import React = require('react')
import { Widget, Action, mkWidget, nothing, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { CustomBlockData } from '../types.mod'
import { ExtraImages } from '../../../utils/extra_images.mod'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { CookieSensitiveContentWrapper, CookieSensitiveContentWrapperStyle } from '../../../../cms/blocks/cookiebar.mod'
import InView from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../drupal/rendering/inview_utils.mod'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { GetCookiebarContent, GetCookiebarButton } from '../../../../drupal/rendering/cookiebar_utils.mod'
import { setCookie } from '../../../../cms/blocks/cookiebar.utils.mod'

export type HubspotIFrameProps = {
  index: number
  useCookieBar: boolean
  cookiePlaceholder?: JSX.Element | string
  cookieButton?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
  inputfields: inputfields
}

export type inputfields = {
  portalID: string
  formID: string
}

export type HubSpotFrameBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

declare const hbspt: any

const script = (portalID: string, formID: string) =>
  hbspt.forms.create({
    portalId: portalID,
    formId: formID,
    target: '#hubspotiframe'
  })

export function hubspotIFrameBlock(
  props: HubspotIFrameProps,
  options?: { style?: HubSpotFrameBlockStyle; key?: string }
): Widget<Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
  return mk_widget({
    run: (onDone) => (
      <InView
        as="section"
        onChange={(inView) =>
          blockInviewHandler(
            'hubspotIframe',
            inView,
            `io-${options && options.key ? options.key : props.index}`,
            getClassName(options, 'inview_classname', 'inview')
          )
        }
        triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
        threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
        id={`io-${options && options.key ? options.key : props.index}`}
        className={getClassName(options, 'block_classname', 'container')}
        key={options && options.key ? options.key : `block-${props.index}`}
      >
        <div className={getClassName(options, 'inner_classname', 'py-5')}>
          <div className={getClassName(options, 'content_classname', '')}>
            <div className={getClassName(options, 'iframe_classname', '')}>
              {props.useCookieBar ? (
                <CookieSensitiveContentWrapper
                  groupId={4}
                  options={{
                    style:
                      options && options.style
                        ? {
                            cookies_classname: options.style.cookies_classname,
                            cookies_inner_classname: options.style.cookies_inner_classname,
                            cookies_text_classname: options.style.cookies_text_classname,
                            cookies_clickable_classname: options.style.cookies_clickable_classname
                          }
                        : undefined
                  }}
                  placeholder={
                    <div className="media__placeholder">
                      <div className="media__inner">
                        <p>{props.cookiePlaceholder}</p>
                        {/* <a className='optanon-toggle-display' onClick={() => Optanon.ToggleInfoDisplay()}>{props.cookieButton}</a> */}
                        <a className='' onClick={() => {
                            setCookie('so_you_accepted_the_cookies?', 'yes_i_did', 100000)
                            window.location.reload()
                          }}>{props.cookieButton}</a>
                      </div>
                    </div>
                  }
                  button={props.cookieButton ? props.cookieButton : ''}
                >
                  <HubspotIFrame
                    portalID={props.inputfields.portalID}
                    formID={props.inputfields.formID}
                  ></HubspotIFrame>
                </CookieSensitiveContentWrapper>
              ) : (
                <HubspotIFrame portalID={props.inputfields.portalID} formID={props.inputfields.formID}></HubspotIFrame>
              )}
            </div>
          </div>
        </div>
      </InView>
    )
  })
}

export class HubspotIFrame extends React.Component<inputfields, {}> {
  componentDidMount() {
    script(this.props.portalID, this.props.formID)
  }

  render() {
    return <div id="hubspotiframe" className="block__inner container container--m"></div>
  }
}
